import React, { useState } from "react";
import { Box, Button, Typography, Grid, Container } from "@mui/material";

const TicTacToe = () => {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [isXNext, setIsXNext] = useState(true);

  const calculateWinner = (squares) => {
    const lines = [
      [0, 1, 2], [3, 4, 5], [6, 7, 8],
      [0, 3, 6], [1, 4, 7], [2, 5, 8],
      [0, 4, 8], [2, 4, 6],
    ];
    for (let [a, b, c] of lines) {
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
        return squares[a];
      }
    }
    return null;
  };

  const winner = calculateWinner(board);

  const isBoardFull = board.every(square => square !== null); // Check if board is full

  const handleClick = (index) => {
    if (board[index] || winner) return;
    const newBoard = board.slice();
    newBoard[index] = isXNext ? "X" : "O";
    setBoard(newBoard);
    setIsXNext(!isXNext);
  };

  const resetGame = () => {
    setBoard(Array(9).fill(null));
    setIsXNext(true);
  };

  return (
    <Container sx={{ textAlign: "center", py: 4 }}>
      <Typography variant="h3" fontWeight="bold" gutterBottom>
        Tic Tac Toe
      </Typography>

      <Grid container spacing={1} justifyContent="center" maxWidth="300px" margin="auto">
        {board.map((square, index) => (
          <Grid item xs={4} key={index}>
            <Button
              variant="outlined"
              sx={{
                width: "80px",
                height: "80px",
                fontSize: "32px",
                fontWeight: "bold",
                backgroundColor: "#fafafa",
                "&:hover": {
                  backgroundColor: "#f9004d",
                  color: "white",
                }
              }}
              onClick={() => handleClick(index)}
            >
              {square}
            </Button>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h5" mt={4}>
        {winner 
          ? `Winner: ${winner}` 
          : isBoardFull 
            ? "Match Tied!" 
            : `Next Player: ${isXNext ? "X" : "O"}`
        }
      </Typography>

      <Button
        variant="contained"
        onClick={resetGame}
        sx={{
          mt: 4,
          backgroundColor: "#f9004d",
          fontWeight: "bold",
          "&:hover": {
            backgroundColor: "white",
            color: "#f9004d",
            border: "1px solid #f9004d"
          }
        }}
      >
        Restart Game
      </Button>
    </Container>
  );
};

export default TicTacToe;
